export default __webpack_public_path__ + "static/media/partner5.3ecd389e.png";